App.namespace.wrap('es6.shared.default_form_handler', function (options = {}) {
  const FormValidation = App.es6.shared.form_validation;

  const {
    formClass = '.js-default-form-handler',
    onSubmitSuccess,
    onSubmitError,
    customValidatorFn,        // (Optional) - custom function to validate the form before submit
  } = options

  const ERROR_CLASS = 'has-error';
  const FIELD_PARENT = '.form-group';
  const ERROR_TARGET_FIELD_ATTR = 'data-error-target'

  /**
   * Add errors from ajax response to the form
   *
   * @param $form - jQuery object
   * @param errors - object which keys have the same names as the corresponding fields in the form
   */
  const showAjaxErrors = ({ $form, errors = {} }) => {
    Object.keys(errors).forEach((field) => {
      const $errorField = $form.find(`[${ERROR_TARGET_FIELD_ATTR}="${field}"]`)
      const text = Array.isArray(errors[field]) ? errors[field].join('<br>') : errors[field];
      if (text.length > 0) {
        $errorField.html(text);
        $errorField.closest(FIELD_PARENT).addClass(ERROR_CLASS);
      }
    });
  }

  /**
   * If form has ajax attribute, we send it via javascript
   *
   * @param $form - jQuery object
   */
  const sendAjaxRequest = ({ $form }) => {
    const submitUrl = $form.prop('action')
    const data = $form.serialize({ checkboxesAsBools: true });
    return $.ajax({
      url: submitUrl,
      data,
      method: 'POST',
      dataType: 'json',
      success: function (response) {
        if (typeof onSubmitSuccess === 'function') {
          onSubmitSuccess(response)
        } else if (response.redirectUrl) {
          window.location = response.redirectUrl
        }
      },
      error: function (response) {
        showAjaxErrors({ $form, errors: response.responseJSON })
        if (typeof onSubmitError === 'function') {
          onSubmitError(response.responseJSON, $form)
        }
      }
    })
  }

  /**
   * Run validation on the form and proceed with submit
   *
   * @param e - submit event
   * @returns {boolean}
   */
  const validateForm = (e) => {
    const $form = $(e.currentTarget);

    if (typeof customValidatorFn === 'function') {
      // Prevent submit if the form doesn't pass the custom validator function
      if (!customValidatorFn($form)) {
        return false
      }
    }

    const $btnSubmit = $form.find('[type=submit]');
    const formValidator = FormValidation({ $form });
    formValidator.init();
    $btnSubmit.hasLoadingState(true)

    if (!formValidator.validate()) {
      // Validation failed
      e.preventDefault();
      $btnSubmit.hasLoadingState(false)
      return false;
    }

    if ($form.attr('ajax')) {
      // Send AJAX form
      e.preventDefault()
      sendAjaxRequest({ $form })
        .always(() => {
          $btnSubmit.hasLoadingState(false)
        })
    }

    if (options.onSuccessfulValidation && typeof options.onSuccessfulValidation === 'function') {
      options.onSuccessfulValidation();
    }

    // Send classic form
    return true;
  };

  const registerEvents = () => {
    $(formClass).on('submit', validateForm);
  };

  const init = () => {
    registerEvents();
  };

  return {
    init,
    sendAjaxRequest,
  };
});

